<!--

This is a utility module that lets you create a title, followed by an icon,
size with an optional underline mode

Editable parameters: icon, color, underline. The icon is a material icon from
Google's collection. Check here: https://material.io/icons/ . The size
is based on em's, and is optional.

Example usage

<icon-text icon="event" color="blue5" underline="true" size="2">
  <p>
    Text here
  </p>
</icon-text>

-->

<template>
  <div class="mt-2 mb-3">

    <template v-if="icon">
      <div class="icon-wrap text-dark">
        <i v-bind:class="{[colorIcon] : true}" class="material-icons">{{icon}}</i> 

        <div v-bind:class="{[textColor] : true}">
          &nbsp;{{title}}
        </div>
      </div>
    </template>

    <template v-else>
      <div v-bind:class="{[textColor] : true}" class="regular-wrap">
        {{title}}
      </div>
    </template>

    <div v-if="underline">
      <div class="under-icon-title margin-bottom-05" v-bind:class="{[textColor] : true}"></div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      colorIcon: "text-" + this.iconColor,
      textColor: "text-" + this.color
    }
  },
  props: ['title','icon','icon-color','color','size','underline'],
  created: function() {
    this.checkIconColor()
  },
  methods: {
    checkIconColor: function() {
      if (this.iconColor != null && this.iconColor != "") {
        this.colorIcon = "text-" + this.iconColor
      } else {
        this.colorIcon = "text-secondary"
      }
    }
  }
}
</script>

<style scoped>

.regular-wrap {
  position: relative;
  font-size: 1.25em;
  font-weight: bold;
}

.icon-wrap {
  position: relative;
  padding-left: 1.25em;
  font-size: 1.25em;
  font-weight: bold;
}

.icon-wrap i {
  position: absolute;
  left: 0;
}

.under-icon-title {
  width: 100%;
  margin-top: 0.25rem;
  text-align: center;
  border-bottom: 2px solid;
  border-color: #cdcecf;
}

</style>
